export const areaList = {
  'ain-sokhna': [
    {
      name: 'il-monte-galala',
      label: 'Il Monte Galala',
      pin: { lat: 29.5275, lng: 32.3833 },
    },
    {
      name: 'lavista-1',
      label: 'Lavista 1',
      pin: { lat: 29.6002, lng: 32.3167 },
    },
    {
      name: 'lavista-2',
      label: 'Lavista 2',
      pin: { lat: 29.6025, lng: 32.3175 },
    },
    {
      name: 'lavista-3',
      label: 'Lavista 3',
      pin: { lat: 29.605, lng: 32.3183 },
    },
    {
      name: 'lavista-topaz',
      label: 'Lavista Topaz',
      pin: { lat: 29.6075, lng: 32.3192 },
    },
    {
      name: 'mountain-view-sokhna',
      label: 'Mountain View Sokhna',
      pin: { lat: 29.61, lng: 32.32 },
    },
    { name: 'ein-bay', label: 'Ein Bay', pin: { lat: 29.6125, lng: 32.3208 } },
    { name: 'azha', label: 'Azha', pin: { lat: 29.615, lng: 32.3217 } },
    {
      name: 'stella-di-mare',
      label: 'Stella Di Mare',
      pin: { lat: 29.6175, lng: 32.3225 },
    },
    {
      name: 'telal-sokhna',
      label: 'Telal Sokhna',
      pin: { lat: 29.62, lng: 32.3233 },
    },
  ],
  'north-coast': [
    {
      name: 'hacienda-bay',
      label: 'Hacienda Bay',
      pin: { lat: 30.96, lng: 28.78 },
    },
    { name: 'diplo-3', label: 'Diplo 3', pin: { lat: 31.0, lng: 28.8 } },
    {
      name: 'stella-sidi-abdelrahman',
      label: 'Stella Sidi Abdelrahman',
      pin: { lat: 30.95, lng: 28.77 },
    },
    { name: 'marassi', label: 'Marassi', pin: { lat: 31.02, lng: 28.81 } },
    {
      name: 'lavista-cascada',
      label: 'La Vista Cascada',
      pin: { lat: 31.04, lng: 28.82 },
    },
    { name: 'bianchi', label: 'Bianchi', pin: { lat: 31.06, lng: 28.83 } },
    {
      name: 'seashell-sidi-abdelrahman',
      label: 'Seashell Sidi Abdel Rahman',
      pin: { lat: 31.08, lng: 28.84 },
    },
    { name: 'amwaj', label: 'Amwaj', pin: { lat: 31.1, lng: 28.85 } },
    {
      name: 'hacienda-white',
      label: 'Hacienda White',
      pin: { lat: 31.12, lng: 28.86 },
    },
    {
      name: 'hacienda-red',
      label: 'Hacienda Red',
      pin: { lat: 31.14, lng: 28.87 },
    },
    {
      name: 'telal-north-coast',
      label: 'Telal North Coast',
      pin: { lat: 31.16, lng: 28.88 },
    },
    {
      name: 'ghazala-bay',
      label: 'Ghazala Bay',
      pin: { lat: 31.18, lng: 28.89 },
    },
    {
      name: 'lavista-bay',
      label: 'La Vista Bay',
      pin: { lat: 31.2, lng: 28.9 },
    },
    {
      name: 'swanlake-north-coast',
      label: 'Swanlake North Coast',
      pin: { lat: 31.22, lng: 28.91 },
    },
    {
      name: 'mountain-view-ras-elhekma',
      label: 'Mountain View Ras Elhekma',
      pin: { lat: 31.24, lng: 28.92 },
    },
    { name: 'caesar', label: 'Caesar', pin: { lat: 35.26, lng: 28.93 } },
    { name: 'fouka-bay', label: 'Fouka Bay', pin: { lat: 31.28, lng: 28.94 } },
    { name: 'almaza-bay', label: 'Almaza Bay', pin: { lat: 31.3, lng: 28.95 } },
    { name: 'bay-7', label: 'Bay 7', pin: { lat: 31.3, lng: 28.95 } },
  ],
  'west-cairo': [
    { name: 'new-giza', label: 'New Giza', pin: { lat: 30.02, lng: 31.0 } },
    {
      name: 'palm-hills',
      label: 'Palm Hills',
      pin: { lat: 30.03, lng: 31.01 },
    },
    {
      name: 'Aeon',
      label: 'Aeon',
      pin: { lat: 30.005639169591525, lng: 30.970895535196355 },
    },
    {
      name: 'Karma',
      label: 'Karma',
      pin: { lat: 30.051135156555755, lng: 30.95716474694805 },
    },
    {
      name: 'Boutique Hotel',
      label: 'Boutique Hotel',
      pin: { lat: 30.051135156555755, lng: 30.95716474694805 },
    },
  ],
  'east-cairo': [
    { name: 'lakeview', label: 'Lakeview', pin: { lat: 30.05, lng: 31.45 } },
    {
      name: 'palm-hills-new-cairo',
      label: 'Palm Hills New Cairo',
      pin: { lat: 30.06, lng: 31.46 },
    },
    { name: 'east-town', label: 'East Town', pin: { lat: 30.07, lng: 31.47 } },
    {
      name: 'waterway-1',
      label: 'Waterway 1',
      pin: { lat: 30.08, lng: 31.48 },
    },
    {
      name: 'Mivida',
      label: 'Mivida',
      pin: { lat: 30.000318520549275, lng: 31.541412966498424 },
    },
    {
      name: 'Cairo Festival City',
      label: 'Cairo Festival City',
      pin: { lat: 30.028667367257135, lng: 31.407765211097992 },
    },
    {
      name: 'Villette',
      label: 'Villette',
      pin: { lat: 30.026731153919524, lng: 31.548714040055888 },
    },
    {
      name: 'Boutique Hotel',
      label: 'Boutique Hotel',
      pin: { lat: 30.026731153919524, lng: 31.548714040055888 },
    },
  ],
  'downtown-cairo': [
    {
      name: 'Zamalek Boutique Hotel',
      label: 'Zamalek Boutique Hotel',
      pin: { lat: 30.09, lng: 31.5 },
    },
    {
      name: 'Downtown Boutique Hotel',
      label: 'Downtown Boutique Hotel',
      pin: { lat: 30.09, lng: 31.5 },
    },
  ],
  'el-gouna': [
    {
      name: 'mangroovy',
      label: 'Mangroovy',
      pin: { lat: 27.415914420475207, lng: 33.67828373013614 },
    },
    {
      name: 'down-town',
      label: 'Down Town',
      pin: { lat: 27.396279664139985, lng: 33.67585585106707 },
    },
    { name: 'marina', label: 'Marina', pin: { lat: 27.4081279688609, lng: 33.676914737574066 } },
    { name: 'tawilah', label: 'Tawila', pin: { lat: 27.402551535499494, lng: 33.65126287995056 } },
    { name: 'g-cribs', label: 'G Cribs', pin: { lat: 27.395652886069666, lng: 33.64206253017695 } },
    {
      name: 'joubal-lagoon',
      label: 'Joubal Lagoon',
      pin: { lat: 27.40759839646646, lng: 33.669001981553244 },
    },
  ],
};
